import {
  APP_SETTING_UPDATE_PROJECT_CONSTANT_BEGIN,
  APP_SETTING_UPDATE_PROJECT_CONSTANT_SUCCESS,
  APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE,
  APP_SETTING_UPDATE_PROJECT_CONSTANT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateProjectConstant(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_PROJECT_CONSTANT_BEGIN,
    });
    const { projectId, version, constantId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/constants/${constantId}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_UPDATE_PROJECT_CONSTANT_SUCCESS,
              data: res,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateProjectConstantError() {
  return {
    type: APP_SETTING_UPDATE_PROJECT_CONSTANT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_PROJECT_CONSTANT_BEGIN:
      return {
        ...state,
        updateProjectConstantPending: true,
        updateProjectConstantError: null,
      };

    case APP_SETTING_UPDATE_PROJECT_CONSTANT_SUCCESS:
      return {
        ...state,
        updateProjectConstantPending: false,
        updateProjectConstantError: null,
      };

    case APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE:
      return {
        ...state,
        updateProjectConstantPending: false,
        updateProjectConstantError: action.data.error,
      };

    case APP_SETTING_UPDATE_PROJECT_CONSTANT_DISMISS_ERROR:
      return {
        ...state,
        updateProjectConstantError: null,
      };

    default:
      return state;
  }
}
